import React from 'react';
import { useUserData } from '../hooks';
import { User } from '../types';

export const UserContext = React.createContext<Partial<User> | null>(null);

interface UserProviderProps {
    isAuthenticated?: boolean;
}

export const UserProvider = (
    props,
) => {
    const userData = useUserData(props.isAuthenticated);

    return (
        <UserContext.Provider value={userData}>
            {props.children}
        </UserContext.Provider>
    );
};
